import React from 'react'
import Box from '@mui/material/Box'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'

export default function DataTypeFormPreview({
  documentType,
}) {
  const [value, onChange] = React.useState({})
  console.log('FORM PREVIEW', {value})
  const { schema, uiSchema } = documentType
  const { readonly } = true
  console.log({ schema, uiSchema })
  return <Box>
    <JSONSchemaFormInput {...{
      schema,
      uiSchema,
      value,
      onChange
    }}/>
  </Box>
}
